import ch from "./ch";
import da from "./da";
import de from "./de";
import en from "./en";
import es from "./es";
import fi from "./fi";
import fr from "./fr";
import hu from "./hu";
import it from "./it";
import nl from "./nl";
import pl from "./pl";
import pt from "./pt";
import ro from "./ro";
import ru from "./ru";
import tr from "./tr";
import ua from "./ua";

export default {
    ch,
    da,
    de,
    en,
    es,
    fi,
    fr,
    hu,
    it,
    nl,
    pl,
    pt,
    ro,
    ru,
    tr,
    ua
};



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js